import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

type DeployEligibilityModalProps = {
  open: boolean;
  message: string;
  licenseCount: number;
  agentCount: number;
  onClose: () => void;
};

const StatRow: FC<{ label: string; value: number }> = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" py={0.75}>
    <Typography sx={{ fontSize: 14, color: '#64748B' }}>{label}</Typography>
    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#0F172A' }}>{value}</Typography>
  </Box>
);

export const DeployEligibilityModal: FC<DeployEligibilityModalProps> = ({
  open,
  message,
  licenseCount,
  agentCount,
  onClose,
}) => {
  const agentsLeft = licenseCount - agentCount;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          width: 440,
          maxWidth: 'calc(100vw - 32px)',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <Box px={3} pt={3} pb={2.5}>
        <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#0F172A', mb: 1.5 }}>
          Cannot deploy agent
        </Typography>
        <Typography sx={{ fontSize: 14, color: '#64748B', lineHeight: 1.5, mb: 2 }}>
          {message}
        </Typography>
        <Box
          sx={{
            border: '1px solid #E2E8F0',
            borderRadius: '8px',
            px: 2,
            py: 0.5,
            backgroundColor: '#F8FAFC',
          }}
        >
          <StatRow label="Licenses" value={licenseCount} />
          <StatRow label="Agents Deployed" value={agentCount} />
          <StatRow label="Agents left" value={agentsLeft} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 3,
          py: 2,
          borderTop: '1px solid #E2E8F0',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{ textTransform: 'none' }}
        >
          Close
        </Button>
      </Box>
    </Dialog>
  );
};
